import React from 'react';

import { makeStyles, useTheme } from "@material-ui/core/styles";

import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';

import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

import useMediaQuery from '@material-ui/core/useMediaQuery';


const useStyles = makeStyles(theme => ({
    dialogContent: {
        backgroundColor: theme.palette.grey[200],
    },
    compact: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    dialogTitle: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText
    },
    itemForm: {
        minWidth: 550,
    },
    numberField: {
        maxWidth: 95,
    },
}));

const DialogForm = (props) => {
    const {
        item,
        onSave,
    } = props;

    const _defaultState = (data) => (
        {
            item_order: data.item_order,
            item_name: data.item_name,
            item_text: data.item_text,
            item_status: data.item_status,
            item_category_id: data.item_category_id,
            modified: false
        }
    );

    const defaultState = _defaultState(item);

    const [state, setState] = React.useState(defaultState);

    const handleChange = name => event => {
        let value;
        if (name == 'item_status') {
            value = event.target.checked ? 'Active' : 'Inactive';
        } else {
            value = event.target.value;
        }
        setState({
            ...state,
            [name]: value,
            modified: true
        })
    }

    const handleSaveSuccess = () => {
        alert('Successfully saved');
        onSave();
    }

    const handleSaveClick = () => {
        const formData = {
            ...state,
            _token: window._token
        };
        const url = `/api/admin/ceremony/templates/items/${item.item_id}`;
        fetch(url, {
            method: 'POST',
            body: JSON.stringify(formData),
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(response => {
            return response.json();
        })
        .then(result => {
            handleSaveSuccess();
            setState({
                ...state,
                modified: false
            });
        })
        .catch(reason => {
            alert('Please try again');
        })
    }

    const classes = useStyles();

    return (
        <React.Fragment>
            <Grid container spacing={1} className={classes.itemForm}>
                <Grid item xs={2}>
                    <TextField
                        fullWidth
                        margin="dense"
                        label="Order"
                        type="number"
                        value={state.item_order}
                        onChange={handleChange('item_order')}
                        variant="outlined"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        className={classes.numberField}
                    />
                </Grid>
                <Grid item xs={9}>
                    <TextField
                        fullWidth
                        margin="dense"
                        label="Name"
                        value={state.item_name}
                        onChange={handleChange('item_name')}
                        variant="outlined"
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </Grid>
            </Grid>
            <Grid container spacing={1}>
                <Grid item xs={2}></Grid>
                <Grid item xs={9}>
                    <TextField
                        fullWidth
                        margin="dense"
                        label="Text"
                        value={state.item_text}
                        onChange={handleChange('item_text')}
                        variant="outlined"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        multiline
                    />
                </Grid>
            </Grid>
            <Grid container spacing={1}>
                <Grid item xs={2}></Grid>
                <Grid item xs={9}>
                    <Box ml={0} display="inline-block">
                        <FormControlLabel
                            control={
                            <Checkbox
                                checked={state.item_status == 'Active'}
                                onChange={handleChange('item_status')}
                                name="item_status"
                                color="primary"
                            />
                            }
                            label="Active"
                        />
                    </Box>
                </Grid>
            </Grid>
            <Grid container spacing={1}>
                <Grid item xs={2}></Grid>
                <Grid item xs={9}>
                    <Button variant="contained" color="primary" onClick={handleSaveClick}>Save</Button>
                </Grid>
            </Grid>
        </React.Fragment>
    )
}

const ItemBuilderDialog = (props) => {
    const {
        open,
        handleClose,
        handleSave,
        scroll,
        item,
    } = props;

    const classes = useStyles();
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <React.Fragment>
            {open && item && (
                <Dialog
                    open={open}
                    onClose={handleClose}
                    scroll={scroll}
                    maxWidth="lg"
                    aria-labelledby="scroll-dialog-title"
                    aria-describedby="scroll-dialog-description"
                    fullScreen={fullScreen}
                >
                    <DialogTitle
                        id="scroll-dialog-title"
                        className={classes.dialogTitle}
                    >
                        <Grid
                            container
                            direction="row"
                            justify="space-between"
                            alignItems="center"
                        >
                            <Grid item>
                                {`Edit Ceremonial Element`}
                            </Grid>
                        </Grid>
                    </DialogTitle>
                    <DialogContent dividers={scroll === 'paper'} className={classes.dialogContent}>
                        <DialogContentText component="div" className={classes.compact}>
                            <DialogForm item={item} onSave={handleSave} />
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose} color="primary">
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
            )}
        </React.Fragment>
    );
}

export default ItemBuilderDialog;
